import type { Video } from '@blackblack/shared';
import { api } from '../../lib/api';
import { useQuery } from '../../lib/query';
import { goBack, useLocation, useParams } from '../../lib/router';
import { Icon } from '../../components/ui/Icon';
import { Button, EmptyState } from '../../components/ui/primitives';
import { VerticalFeed } from './VerticalFeed';
import styles from './feed.module.css';

/**
 * A single video (shared link) or a swipeable list opened from a grid
 * (profile, sound, hashtag): navigation state carries { videos, index }.
 */
export function VideoPage() {
  const { id } = useParams<{ id: string }>();
  const { state } = useLocation();
  const list = (state as { videos?: Video[]; index?: number } | null)?.videos;
  const single = useQuery<Video>(list ? null : `video:${id}`, () => api.get<Video>(`/videos/${id}`));

  const items = list ?? (single.data ? [single.data] : []);
  const index = list ? ((state as { index?: number }).index ?? 0) : 0;

  return (
    <div className={styles.page}>
      <header className={styles.topBar}>
        <button className={styles.topIcon} onClick={() => goBack('/')} aria-label="Terug">
          <Icon name="back" size={24} />
        </button>
      </header>
      <div className={styles.feedHost}>
        {single.error ? (
          <div className={styles.emptyWrap}>
            <EmptyState icon="alert" title="Video niet beschikbaar" text="Deze video is verwijderd of privé." action={<Button onClick={() => goBack('/')}>Terug</Button>} />
          </div>
        ) : (
          <VerticalFeed items={items} hasMore={false} loading={single.loading} onNearEnd={() => {}} active initialIndex={index} />
        )}
      </div>
    </div>
  );
}
